import React from 'react';
import { IntakeForm } from './components/IntakeForm';
export function App() {
  return <IntakeForm data-id="element-0" />;
}